import { render, staticRenderFns } from "./CourseCatalog.vue?vue&type=template&id=c22fd2c2&scoped=true&"
import script from "./CourseCatalog.vue?vue&type=script&lang=js&"
export * from "./CourseCatalog.vue?vue&type=script&lang=js&"
import style0 from "./CourseCatalog.vue?vue&type=style&index=0&id=c22fd2c2&lang=scss&scoped=true&"
import style1 from "./CourseCatalog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22fd2c2",
  null
  
)

export default component.exports